import {Component, OnInit} from '@angular/core';
import {SocialMediaWidgetSvgSpriteComponent} from './socail-media-widget-svg-sprite.component';
import {TenantService} from '../../services/tenant.service';
import {AppState} from '../../store';
import {select, Store} from '@ngrx/store';
import {selectTenantInfo, selectUserPermissions} from '../../store/selectors';
import {SocialMediaBarConfig, SocialMediaPlatform} from '../../models/social-media-bar-config.model';
import {NgClass, NgFor, NgIf} from '@angular/common';
import {MessagesService} from "../services/messages.service";
import {combineLatest} from "rxjs";
import {UserPermissions} from "../../models/user-permissions.model";
import {Router} from "@angular/router";
import {DEFAULT_SOCIAL_MEDIA_BAR_CONFIG} from "../utils/social-media-config";
import {Meta, Title} from "@angular/platform-browser";
import {user} from "@angular/fire/auth";

const DOMAIN_HOST = 'https://onlinecoursehost.com/'

@Component({
  selector: 'social-media-widget',
  standalone: true,
  imports: [SocialMediaWidgetSvgSpriteComponent , NgClass , NgFor , NgIf],
  templateUrl: './social-media-widget.component.html',
  styleUrl: './social-media-widget.component.scss'
})
export class SocialMediaWidgetComponent implements OnInit {

  socialMediaBar: SocialMediaBarConfig;
  socialMediaBarPlatforms: SocialMediaPlatform[];
  userPermissions: UserPermissions

  constructor(
    private tenant: TenantService,
    private store: Store<AppState>,
    private messagesService: MessagesService,
    private router: Router,
    private title: Title,
    private meta: Meta
  ) { }

  ngOnInit() {

    combineLatest([
      this.store.pipe(select(selectTenantInfo)),
      this.store.pipe(select(selectUserPermissions))
    ])
      .subscribe(([tenant, userPermissions]) => {

        this.socialMediaBar = tenant.socialMediaBarConfig || DEFAULT_SOCIAL_MEDIA_BAR_CONFIG;
        this.userPermissions = userPermissions;

        this.socialMediaBarPlatforms =
          this.socialMediaBar.platforms
            .filter((platform) => {

              const disallow = userPermissions.isAdmin || userPermissions.isPlatformAdmin ? [] : ['Settings']

              return !disallow.includes(platform.name);

            })

      });

    this.store.pipe(select(selectTenantInfo)).subscribe((tenant) => {

      // this.socialMediaBar = tenant.socialMediaBarConfig;
      //
      // this.socialMediaBarPlatforms =
      //   this.socialMediaBar.platforms
      //     .filter((platform) => {
      //       return !['WhatsApp', 'Settings'].includes(platform.name);
      //     })
      //
      // console.log('Updated social media config:', this.socialMediaBar, this.socialMediaBarPlatforms);
    });


  }

  getPlatformClass(platformName: string): string {
    switch (platformName) {
      case 'Facebook':
        return 'bg-1';
      case 'Twitter':
        return 'bg-2';
      case 'Instagram':
        return 'bg-3';
      case 'LinkedIn':
        return 'bg-4';
      case 'Pinterest':
        return 'bg-5';
      case 'WhatsApp':
        return 'bg-6';
      case 'Email':
        return 'bg-7';
      case 'Settings':
        return 'bg-8';
      default:
        return '';
    }
  }

  sharePlatform(platform: SocialMediaPlatform) {
    // detect the url and use it to form the url.

    console.log(platform)

    if (platform.name === 'Settings' && this.userPermissions.isAdmin) {
      this.router.navigate(['/admin/settings/school-settings/navigation'])
      return;
    }

    const url = this.buildShareUrl();

    if (url) {

      const shareUrl = this.buildSocialShareUrl(platform, url)

      console.log('shareUrl:', shareUrl);

      if (shareUrl) {

        window.open(shareUrl, '_blank');

      }

    }

  }

  buildShareUrl() {

    const pathname = window.location.pathname;

    const pathnameParts = pathname.split('/').filter(Boolean)

    const baseUrl = `${DOMAIN_HOST}social-sharing/${this.tenant.id}/`

    const basePathname = pathnameParts[0];

    switch (basePathname) {

      // check if we are in courses page
      case 'courses':
        // pick the course url and build share
        const courseUrl = pathnameParts?.[1];

        // support for course page
        if (!courseUrl) {
          return baseUrl + 'courses-page'
        }

        // check for lessons page
        // support lessons:
        // /courses/published-course/1/lessons/2
        // /courses/:courseUrl/:sectionSeqNo/lessons/:lessonSeqNo

        if (pathnameParts.length === 5 && pathnameParts[3] === 'lessons') {
          return baseUrl + 'lesson-url' + pathname;
        }

        return baseUrl + 'courses/' + courseUrl;

      case 'pages':
          const pageUrl = pathnameParts[1];
          return baseUrl + 'pages/' + pageUrl;

      case 'home':
        return window.location.host + '/home';

      case 'admin':
        this.messagesService.warn(`Social sharing from Admin is not supported.`)
        return null

      default:
        this.messagesService.warn(`Social sharing from this page is not supported.`)
        return null // window.location.host;

    }

  }

  buildSocialShareUrl(platform: SocialMediaPlatform, url: string) {

    const socialShareName = platform.name;
    const facebookAppId = '';

    const pageTitle = this.getPageTitle();
    const pageDescription = this.getPageDescription();

    const text = `${pageTitle} ${pageDescription}`.trim();

    if (!url) {
      console.error('No URL provided for social share.');
      this.messagesService.error('No URL provided for social share.')
      return '';
    }

    switch (socialShareName) {
      case 'Twitter':
        return `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(url)}`;

      case 'LinkedIn':
        // return `https://www.linkedin.com/feed/?shareActive=true&shareUrl=${encodeURIComponent(url)}`
        return `https://www.linkedin.com/shareArticle/?title=${text}&url=${encodeURIComponent(url)}`

      case 'WhatsApp':

        // return `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
        const messageUrl = encodeURIComponent(text + url)

        return "https://wa.me/?text=" + messageUrl;

      case 'Facebook':
        // return `https://www.facebook.com/dialog/share?app_id=${facebookAppId}&display=popup&href=${encodeURIComponent(url)}`;
        return `https://www.facebook.com/sharer.php?t=${text}&u=${encodeURIComponent(url)}`
        // return `https://www.facebook.com/share_channel/?link=${encodeURIComponent(url)}&app_id=${facebookAppId}&source_surface=external_reshare&display&hashtag`

      case 'Pinterest':
        return `https://www.pinterest.com/pin/create/button/?description=${text}&media=&url=${encodeURIComponent(url)}`

      case 'Email':
        return `mailto:?subject=${text}&body=${encodeURIComponent(url)}`;

      default:
        console.warn(`Social sharing for ${socialShareName} is not supported.`);
        this.messagesService.warn(`Social sharing for ${socialShareName} is not supported.`)
        return '';
    }
  }

  getPageTitle() {
    return this.title.getTitle() || '';
  }

  getPageDescription() {

    const description = this.meta.getTag('name="description"')?.content;

    if (description) {

      return description;

    }

    return ''

  }

}
